<!--
    @file:车辆搜索模块.
    @props: {arry} serchData 后台数据库的搜索结果,在搜索结果的表格里面展示
    @props: {arry} showConfirmBt 是否展示模块下面的确定/取消 按钮
    @emit: {object} search 给父组件传递搜索条件
        {
            battery_code: String,
            plate_number: String,
            production_vehicle_no: String,
            rows: Number,
            page: Number,
            sort_type: String,//desc asc
            sort_by: String,
            run_status: arry //[0,1,2]
        }
    @emit {object} select 给父组件传递选中的对象
    @emit cancelSelect 执行了放弃选中,告知夫组件
-->

<template>
    <div id="search-cars">
        <p class="title"><span>车辆信息</span></p>
        <el-form  :model="ruleForm" ref="ruleForm" class="search-form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="电池编号" prop="battery_code" >
                        <el-autocomplete
                            v-model="ruleForm.battery_code"
                            :fetch-suggestions="queryBattery"
                            placeholder="请输入"
                        ></el-autocomplete>
                    </el-form-item>

                </el-col>
                <el-col :span="12">
                    <el-form-item label="厂家车辆编号" prop="production_vehicle_no" >
                        <el-autocomplete
                            v-model="ruleForm.production_vehicle_no"
                            :fetch-suggestions="queryProduction"
                            placeholder="请输入"
                        ></el-autocomplete>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="车牌号码" prop="plate_number">
                        <el-autocomplete
                            v-model="ruleForm.plate_number"
                            :fetch-suggestions="queryPlate"
                            placeholder="请输入"
                        ></el-autocomplete>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="50">
                <el-col :span="12">
                    <el-button type="primary" @click="resetForm('ruleForm')">重置</el-button>
                </el-col>
                <el-col :span="12">
                    <el-button  type="primary" @click="submitForm('ruleForm')">查询</el-button>
                </el-col>
            </el-row>
        </el-form>
        <p class="title"><span>共查询到 {{ dataTotal }} 条数据</span></p>
        <el-table
        height="296"
        class="search-table"
        :data="tableData"
        style="width: 100%"
        highlight-current-row
        @filter-change="handleFilterChange"
        @sort-change="sortChange"
        @current-change="handleTableCurrentChange">
            <el-table-column
                label=""
                width="26">
                <template scope="scope">
                    <el-radio class="radio" v-model="radio" :label="scope.row.id"></el-radio>
                </template>
            </el-table-column>
            <el-table-column prop="battery_code" label="电池编号" sortable="custom" ></el-table-column>
            <el-table-column prop="plate_number" label="车牌号码" sortable="custom" ></el-table-column>
            <el-table-column prop="production_vehicle_no" label="厂家车辆编号" sortable="custom"></el-table-column>
            <el-table-column prop="soc" label="SOC(%)" width="45"></el-table-column>
            <el-table-column prop="velocity" label="速度 (km/h)" width="45"></el-table-column>
            <el-table-column
                prop="run_status"
                label="运行状态"
                width="80"
                :filters="filters">
                <template scope="scope" >
                    <span class="poit-left alarm" v-if="scope.row.run_status === 0">报警中</span>
                    <span class="poit-left run" v-if="scope.row.run_status === 1">运行中</span>
                    <span class="poit-left stop" v-if="scope.row.run_status === 2">停止中</span>
                </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="60">
              <template scope="scope">
                <el-popover
                  ref="popover1"
                  placement="right"
                  trigger="hover">
                  <div class="tip-info">
                    <p class="title"><span>车辆基本信息</span></p>
                    <el-row>
                        <el-col :span="8">
                            <span class="tip-lable">车牌号</span>
                            <span class="tip-value">{{ scope.row.plate_number }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">车型</span>
                            <span class="tip-value">{{ scope.row.car_model }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">厂家车辆编号</span>
                            <span class="tip-value">{{ scope.row.production_vehicle_no }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">能源类型</span>
                            <span class="tip-value">{{ scope.row.energy_type }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">安装时间</span>
                            <span class="tip-value">{{ scope.row.install_date }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">VIN码</span>
                            <span class="tip-value">{{ scope.row.id }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">驾驶员</span>
                            <span class="tip-value">{{ scope.row.driver }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">驾驶员电话</span>
                            <span class="tip-value">{{ scope.row.driver_phone }}</span>
                        </el-col>
                    </el-row>
                    <div class="line"></div>
                    <el-row>
                        <el-col :span="8">
                            <span class="tip-lable">充电次数</span>
                            <span class="tip-value">{{ scope.row.charge_times }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">运行天数</span>
                            <span class="tip-value">{{ scope.row.run_days }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">平均耗能</span>
                            <span class="tip-value">{{ scope.row.average_energy_consumption }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">实际里程数</span>
                            <span class="tip-value">{{ scope.row.mileage }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">累积运行时间</span>
                            <span class="tip-value">{{ scope.row.histroy_run_time }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">累积耗能</span>
                            <span class="tip-value">{{ scope.row.history_energy_consumption }}</span>
                        </el-col>
                    </el-row>
                    <p class="title"><span>车辆电池信息</span></p>
                    <el-row>
                        <el-col :span="8">
                            <span class="tip-lable">电池编码</span>
                            <span class="tip-value">{{ scope.row.battery_code }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">电池生产厂家编码</span>
                            <span class="tip-value">{{ scope.row.battery_vendor_code }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">电池生产日期</span>
                            <span class="tip-value">{{ scope.row.battery_code }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">电池类型</span>
                            <span class="tip-value">{{ scope.row.battery_type }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">电池额定电压</span>
                            <span class="tip-value">{{ scope.row.rated_voltage }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">电池额定电量</span>
                            <span class="tip-value">{{ scope.row.rated_capacity }}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="tip-lable">电池额定电能</span>
                            <span class="tip-value">{{ scope.row.rated_energy }}</span>
                        </el-col>
                    </el-row>
                  </div>
                </el-popover>
                <el-button  type="text" size="small" v-popover:popover1>查看</el-button>
              </template>
            </el-table-column>
        </el-table>
        <div class="block" v-if="showPagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout=" prev, pager, next, sizes, jumper"
              :total="dataTotal">
            </el-pagination>
        </div>
        <el-row :gutter="50" v-if="showConfirmBt" class="bt-popover">
            <el-col :span="12">
                <el-button type="primary" @click="cancelSelect">取消</el-button>
            </el-col>
            <el-col :span="12">
                <el-button type="primary" @click="comfirmSelect">确定</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'search',
    data () {
        return {
            ruleForm: {
                battery_code: '',
                plate_number: '',
                production_vehicle_no: ''
            },
            currentPage: 1,
            pageSize: 10,
            radio: '',
            selectCar: {},
            timeout: null,
            sort_type: '',
            sort_by: '',
            run_status: [0, 1, 2],
            filters: [{ text: '报警中', value: 0 }, { text: '运行中', value: 1 }, { text: '停止中', value: 2 }]
        };
    },
    props: ['serchData', 'showConfirmBt'],
    methods: {
        getTableList () {
            this.$emit('search', this.searchQuery);
        },
        querySearchAsync (field, queryString, cb) {
            var self = this;
            var url = this.Api.filter + '?field=' + field + '&value=' + queryString + '&rows=5';
            this.$ajax.get(url)
            .then(function (res) {
                if (res.status === 200) {
                    cb(self.getDataFormat(res.data));
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getDataFormat (data) {
            var result = [];
            for (var i = 0, len = data.length; i < len; i++) {
                result.push({value: data[i]});
            }
            return result;
        },
        queryBattery (queryString, cb) {
            this.querySearchAsync('battery_code', queryString, cb);
        },
        queryProduction (queryString, cb) {
            this.querySearchAsync('plate_number', queryString, cb);
        },
        queryPlate (queryString, cb) {
            this.querySearchAsync('production_vehicle_no', queryString, cb);
        },
        handleSizeChange (val) {
            this.getTableList();
        },
        handleCurrentChange (val) {
            this.getTableList();
        },
        handleTableCurrentChange (val) {
            this.radio = val.battery_code;
            if (this.showConfirmBt) {
                this.selectCar = val;
            } else {
                this.$emit('select', val);
            }
        },
        submitForm (formName) {
            this.getTableList();
        },
        resetForm (formName) {
            this.$refs[formName].resetFields();
        },
        sortChange (item) {
            this.sort_by = item.prop;
            this.sort_type = item.order.substr(0, 4);
            this.getTableList();
        },
        handleFilterChange (filters) {
            this.run_status = filters['el-table_1_column_7'];
            this.getTableList();
        },
        cancelSelect () {
            this.$emit('cancelSelect');
        },
        comfirmSelect () {
            this.$emit('select', this.selectCar);
        }
    },
    computed: {
        tableData: function () {
            return this.serchData.vehicles;
        },
        dataTotal: function () {
            return this.serchData.hits ? this.serchData.hits : 0;
        },
        searchQuery: function () {
            return {
                battery_code: this.ruleForm.battery_code,
                plate_number: this.ruleForm.plate_number,
                production_vehicle_no: this.ruleForm.production_vehicle_no,
                rows: this.pageSize,
                page: this.currentPage,
                sort_type: this.sort_type,
                sort_by: this.sort_by,
                run_status: this.run_status
            };
        },
        showPagination: function () {
            return this.dataTotal > 10;
            // return (this.dataTotal / this.pageSize) > 1;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#search-cars {
    background-color: #fff;
    padding: 10px;
    height: 80vh;
    min-height: 680px;
    box-sizing: border-box;
}
.search-table{
    font-size: 12px;
    text-align: center;
    border-left: 0;
}
.search-form{
    background-color: #f3f3f3;
    margin-bottom: 20px;
    padding: 20px 15px;
    text-align: left;
}
.title{
    color:#5182e4;
    position: relative;
    height: 20PX;
    margin: 10px 0 20px 0;
}
.title span{
    background: #fff;
    display: inline-block;
    position: absolute;
    padding: 0 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
}
.title::before{
    content: "";
    height: 1px;
    background-color: #5182e4;
    position: absolute;
    right: 10px;
    left: 10px;
    top:10px;
}
.el-input{
    max-width: 150px;
}
.el-button--primary{
    width: 100%;
    background-color: #5182e4;
    border-color: #5182e4;
    color:#fff;
    padding: 7px 15px;
    border-radius: 0;
}
.el-button--primary:hover{
    background-color: #0066ff;
}
.bt-popover{
    margin-top:30px;
}
.el-autocomplete{
    max-width: 120px;
}
.el-pagination{
    padding: 0;
    margin: 30px 0 10px 0;
    overflow: hidden;
    text-align: center;
}
.tip-info{
    width: 640px;
    height: 360px;
}
.tip-lable{
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-bottom: 10px;
    padding-right: 4px;
    box-sizing: border-box;
    color: #7f8393;
}
.tip-value{
    display: inline-block;
    width: 100px;
    text-align: left;
    border:1px solid #ddd;
    margin-bottom: 10px;
    padding-left: 4px;
    box-sizing: border-box;
}
.tip-info .el-row{
    padding: 0 20px 0 0px;
}
.alarm{
    color: #e00000;
}
.run{
    color: #1e9600;
}
.stop{
    color: #999;
}
.poit-left:before{
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #1e9600;
    border-radius: 50%;
    margin-bottom: 2px;
    margin-right: 3px;
}
.stop:before{
    background-color: #999;
}
.alarm:before{
    background-color: #e00000;
}
.line{
    width: auto;
    border-bottom: 1px dashed #eee;
    margin:10px 20px 15px 20px;
}
.el-table::after{
    display: none;
}

</style>
<style>
.el-popover[x-placement^=right]{
    margin-right:
}
.el-radio__inner{
    width: 14px;
    height: 14px;
}
.el-radio__label{
    display: none;
}
.el-radio__inner:hover{
    border-color: #5182e4;
}
.el-radio__inner::after{
    width: 5px;
    height: 5px;
    background-color: #5182e4;
}
.el-radio__input.is-checked .el-radio__inner{
    background-color: #fff;
    border-color: #5182e4;
}
#search-cars .cell{
    padding:5px;
    text-align: center;
    font-weight: normal;
    line-height: 1.5;

}
#search-cars th>.cell{
    background-color: #f3f3f3;
}
#search-cars .caret-wrapper{
    position: absolute;
    margin-left: 0;
    margin-top:-6px;
}
#search-cars th{
    background-color: #f3f3f3;
}

#search-cars .el-input__inner{
    border-radius: 0;
    height: 26px;
    padding:0 10px;
    border-color: #e0e3e7;

}
#search-cars .el-pagination li,
#search-cars .el-pagination button{
    border-radius: 2px;
    margin-right: 5px;
    border-right: 1px solid #d1dbe5;
    border-left: 1px solid #d1dbe5;
}
#search-cars  li.active{
    border-color: #5182e4;
    background-color: #5182e4;
}
#search-cars .el-pagination button:not(.disabled):hover,
#search-cars  li:not(.active):hover{
    color: #5182e4;
}
#search-cars .el-pagination__sizes{
    margin-left:15px;
}
.el-checkbox__inner{
    border-radius: 0;
    width: 14px;
    height: 14px;
    border-color: #5182e4;
}
.el-checkbox__inner::after{
    border: 1px solid #5182e4;
    border-left: 0;
    border-top: 0;
    top: 0;
    left: 4px;
}
.el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #fff;
}
#search-cars .el-checkbox__label{
    font-size: 12px;
}
.el-table-filter__bottom{
    text-align: center;
}
.el-table-filter__bottom button{
    font-size: 12px;
    text-align: center;
}
.el-table__column-filter-trigger{
    background:url(../../assets/img/filter.png)  no-repeat center ;
    background-size: contain;
    font-size: 14px;
    margin-left: 1px;

}
.el-table__column-filter-trigger .el-icon-arrow-down{
    visibility: hidden;
}
.el-select-dropdown__item.selected.hover,
.el-select-dropdown__item.selected{
    background-color: #5182e4;
}
::-webkit-scrollbar-track
{
  background-color: #e5e5e5;
  border-radius: 8px;
}

::-webkit-scrollbar
{
  width: 8px;
  height: 8px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
  border-radius: 6px;
  background-color:#abafba;
}
</style>



// WEBPACK FOOTER //
// search.vue?d118c9cc